'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var CircleLoadingSpinner = require('../CircleLoadingSpinner/CircleLoadingSpinner.js');
var styledComponents = require('./styled-components.js');

var LoadingSpinner = function (_a) {
    var _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, children = _a.children, className = _a.className;
    if (isLoading) {
        return (React__default.createElement(styledComponents.SpinnerContainer, { "data-testid": 'loading-spinner', className: className },
            React__default.createElement(CircleLoadingSpinner, null)));
    }
    return children;
};

module.exports = LoadingSpinner;
